import * as Hammer from 'hammerjs';
import { AfterViewInit, Component, ElementRef, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Person } from '../../models/person.model';
import { HammerSwipeAction, Variable } from '../../types/common';
import { PersonsListItemActionType } from '../persons-list/persons-list.component';

export type PersonsVisualizerComponentActionCallback = (action: PersonsListItemActionType, person: Person) => void;

export type PersonsVisualizerComponentData = {
  persons: Person[];
  variables?: Variable[];
  actions?: PersonsListItemActionType[];
  actionsCallback?: PersonsVisualizerComponentActionCallback;
};

@Component({
  selector: 'cm-persons-visualizer',
  templateUrl: './persons-visualizer.component.html',
  styleUrls: ['./persons-visualizer.component.scss'],
})
export class PersonsVisualizerComponent implements OnInit, AfterViewInit {
  @Input() persons: Person[];
  @Input() variables: Variable[] = [];

  first = 0;
  numCards = 1;
  actions: PersonsListItemActionType[] = [];
  actionsCallback: PersonsVisualizerComponentActionCallback;

  constructor(
    @Inject(MAT_DIALOG_DATA) private dialogData: PersonsVisualizerComponentData,
    private dialogRef: MatDialogRef<PersonsVisualizerComponent>,
    private elementRef: ElementRef
  ) {
    if (this.dialogData) {
      this.persons = dialogData.persons || [];
      this.actions = dialogData.actions || [];
      this.actionsCallback = dialogData.actionsCallback ? dialogData.actionsCallback : () => {};
    }
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    const hammerSwipe = new Hammer.Manager(this.elementRef.nativeElement, {
      recognizers: [[Hammer.Swipe, { direction: Hammer.DIRECTION_HORIZONTAL }]],
    });

    // listen to events...
    hammerSwipe.on(`${HammerSwipeAction.LEFT}`, (ev) => {
      this.next();
    });

    // listen to events...
    hammerSwipe.on(`${HammerSwipeAction.RIGHT}`, (ev) => {
      this.prev();
    });
  }

  closeVisualizer() {
    this.dialogRef.close();
  }

  prev() {
    if (this.first > 0) {
      this.first = this.first - this.numCards;
    }
  }

  next() {
    if (this.first + this.numCards < this.persons.length) {
      this.first = this.first + this.numCards;
    }
  }
}
